import{jsx as r}from"react/jsx-runtime";function t(t){return r("img",{...t})}export{t as I};
//# sourceMappingURL=Image-396dca99.js.map
